"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapRootElement = exports.onInitialClientRender = exports.onClientEntry = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJss = require("react-jss");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _styles = require("@material-ui/core/styles");

var _jss = require("jss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var jss = (0, _jss.create)(_objectSpread({}, (0, _styles.jssPreset)(), {
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  insertionPoint: 'jss-insertion-point'
})); // Add the JSS insertion point comment to the top of the head.

var onClientEntry = function onClientEntry() {
  var styleNode = window.document.createComment('jss-insertion-point');
  window.document.head.insertBefore(styleNode, window.document.head.firstChild);
}; // Remove the server-side injected CSS.


exports.onClientEntry = onClientEntry;

var onInitialClientRender = function onInitialClientRender() {
  var ssStyles = window.document.getElementById('server-side-jss');
  ssStyles && ssStyles.parentNode.removeChild(ssStyles);
};

exports.onInitialClientRender = onInitialClientRender;
var defaultOptions = {
  theme: {},
  dangerouslyUseGlobalCSS: false,
  productionPrefix: 'jss'
};

var wrapRootElement = function wrapRootElement(_ref, options) {
  var element = _ref.element;

  var _defaultOptions$optio = _objectSpread({}, defaultOptions, options),
      dangerouslyUseGlobalCSS = _defaultOptions$optio.dangerouslyUseGlobalCSS,
      productionPrefix = _defaultOptions$optio.productionPrefix,
      theme = _defaultOptions$optio.theme;

  var generateClassName = (0, _styles.createGenerateClassName)({
    dangerouslyUseGlobalCSS: dangerouslyUseGlobalCSS,
    productionPrefix: productionPrefix
  });
  return _react["default"].createElement(_reactJss.JssProvider, {
    jss: jss,
    generateClassName: generateClassName
  }, _react["default"].createElement(_styles.MuiThemeProvider, {
    theme: (0, _styles.createMuiTheme)(theme)
  }, _react["default"].createElement(_CssBaseline["default"], null), element));
};

exports.wrapRootElement = wrapRootElement;